import { SeuChangelogItemIcon, SeuChangelogItemType } from '@seu-types';

export function getIconForChangeType(
  changeType: SeuChangelogItemType
): SeuChangelogItemIcon {
  switch (changeType) {
    case 'DETAILS_CHANGED':
    case 'PROJECT_NAME_CHANGED':
      return { name: 'fileinfo-16', color: 'yellow' };
    case 'GLOBAL_PARAMETER_SET_SET_AS_DEFAULT':
    case 'GLOBAL_PARAMETER_SET_ADDED':
    case 'GLOBAL_PARAMETER_SET_CHANGED':
    case 'GLOBAL_PARAMETER_SET_REMOVED':
      return { name: 'slider-16', color: 'orange' };
    case 'OPERATING_CONDITION_ADDED':
    case 'OPERATING_CONDITION_CHANGED':
    case 'OPERATING_CONDITION_REMOVED':
      return { name: 'list-16', color: 'orange' };
    case 'OPEX_CHANGED':
      return { name: 'opex-16', color: 'orange' };
    case 'EMISSION_LIMITS_CHANGED':
      return { name: 'limit-16', color: 'orange' };
    case 'COMPONENT_ADDED':
    case 'COMPONENT_CONFIGURATION_CHANGED':
    case 'COMPONENT_REMOVED':
    case 'COMPONENT_DRAGGED_INTO_CANVAS':
    case 'COMPONENT_REMOVED_FROM_CANVAS':
      return { name: 'puzzle-16', color: 'petrol' };
    case 'CALCULATION_COMBINATION_CHANGED':
    case 'CALCULATION_COMBINATION_ADDED':
    case 'CALCULATION_COMBINATION_REMOVED':
      return { name: 'calculate-16', color: 'purple' };
    case 'CHANGES_IN_CANVAS':
    case 'COMPONENT_NAME_CHANGED_IN_CANVAS':
      return { name: 'canvas-16', color: 'petrol' };
    case 'INTERCONNECTION_ADDED':
    case 'INTERCONNECTION_UPDATED':
    case 'INTERCONNECTION_DUPLICATED':
    case 'INTERCONNECTION_REMOVED':
      return { name: 'stream-multiple-16', color: 'yellow' };
    case 'STREAM_ADDED':
    case 'STREAM_NAME_CHANGED':
    case 'STREAM_REMOVED':
      return { name: 'stream-multiple-16', color: 'petrol' };
  }
}

export function getLabelForChangeType(
  changeType: SeuChangelogItemType
): string {
  switch (changeType) {
    case 'DETAILS_CHANGED':
      return 'changelog.change-types.offer-details-changed';
    case 'PROJECT_NAME_CHANGED':
      return 'changelog.change-types.project-name-changed';
    case 'OPERATING_CONDITION_CHANGED':
      return 'changelog.change-types.operating-condition-changed';
    case 'OPERATING_CONDITION_ADDED':
      return 'changelog.change-types.operating-condition-added';
    case 'OPERATING_CONDITION_REMOVED':
      return 'changelog.change-types.operating-condition-removed';
    case 'OPEX_CHANGED':
      return 'changelog.change-types.opex-changed';
    case 'EMISSION_LIMITS_CHANGED':
      return 'changelog.change-types.emission-limits-changed';
    case 'GLOBAL_PARAMETER_SET_SET_AS_DEFAULT':
      return 'changelog.change-types.global-parameter-set-as-default';
    case 'GLOBAL_PARAMETER_SET_ADDED':
      return 'changelog.change-types.global-parameter-added';
    case 'GLOBAL_PARAMETER_SET_CHANGED':
      return 'changelog.change-types.global-parameter-changed';
    case 'GLOBAL_PARAMETER_SET_REMOVED':
      return 'changelog.change-types.global-parameter-removed';
    case 'COMPONENT_ADDED':
      return 'changelog.change-types.component-added';
    case 'COMPONENT_REMOVED':
      return 'changelog.change-types.component-removed';
    case 'COMPONENT_CONFIGURATION_CHANGED':
      return 'changelog.change-types.component-configuration-changed';
    case 'CALCULATION_COMBINATION_CHANGED':
      return 'changelog.change-types.calculation-combination-changed';
    case 'CALCULATION_COMBINATION_ADDED':
      return 'changelog.change-types.calculation-combination-added';
    case 'CALCULATION_COMBINATION_REMOVED':
      return 'changelog.change-types.calculation-combination-removed';
    case 'CHANGES_IN_CANVAS':
      return 'changelog.change-types.changes-in-canvas';
    case 'COMPONENT_DRAGGED_INTO_CANVAS':
      return 'changelog.change-types.component-dragged-into-canvas';
    case 'COMPONENT_REMOVED_FROM_CANVAS':
      return 'changelog.change-types.component-removed-from-canvas';
    case 'COMPONENT_NAME_CHANGED_IN_CANVAS':
      return 'changelog.change-types.component-name-changed-in-canvas';
    case 'INTERCONNECTION_ADDED':
      return 'changelog.change-types.interconnection-added';
    case 'INTERCONNECTION_UPDATED':
      return 'changelog.change-types.interconnection-updated';
    case 'INTERCONNECTION_REMOVED':
      return 'changelog.change-types.interconnection-removed';
    case 'INTERCONNECTION_DUPLICATED':
      return 'changelog.change-types.interconnection-duplicated';
    case 'STREAM_ADDED':
      return 'changelog.change-types.stream-added';
    case 'STREAM_REMOVED':
      return 'changelog.change-types.stream-removed';
    case 'STREAM_NAME_CHANGED':
      return 'changelog.change-types.stream-name-changed';
    default:
      return changeType;
  }
}
